import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import { changeStep } from 'scenes/ClientDetail/components/AddVehicleModal/actions'

import './style.scss'


const READABLE_STEP = {
  1: 'Primer',
  2: 'Segundo',
  3: 'Tercer',
  4: 'Cuarto',
  5: 'Quinto'
}

export function StepIndicator(props) {
  const step = props.step - 1
  const activeClass = props.currentStep === step ? 'active' : ''

  const _onClick = () => {
    props.currentStep > step && props.changeStep(step)
  }

  const checkIcon = props.currentStep > step ? (
    <span className="material-icons AddVehicleModal__StepIndicator-icon--check">check</span>
  ) : null

  return (
    <div className={`AddVehicleModal__StepIndicator ${activeClass}`} onClick={_onClick}>
      <div className="AddVehicleModal__StepIndicator-icon">
        <span className="material-icons">{props.iconName}</span>
        { checkIcon }
      </div>
      <div className="AddVehicleModal__StepIndicator-label">
        <p className="AddVehicleModal__StepIndicator-label--number">{READABLE_STEP[props.step]} Paso</p>
        <p className="AddVehicleModal__StepIndicator-label--name">{props.name}</p>
      </div>
    </div>
  )
}

StepIndicator.propTypes = {
  step: PropTypes.number.isRequired,
  iconName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func
}


const mapStateToProps = (state) => {
  return {
    currentStep: parseInt(state.addVehicleModal.get('currentStep'), 10)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeStep: (step) => dispatch(changeStep(step)),
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StepIndicator)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/StepIndicator/index.js